import React, { useState } from "react";
import PropTypes from "prop-types";

import { useMutation } from "react-apollo";

import { Title, Fieldset, Field, Control, Button } from "rbx";
import { CREATE_LOCATION_TYPE_MUTATION } from "../../graphql/Locations/LocationTypes.graphql";

import LocationTypeForm from "./LocationTypeForm";

import { makeHandleChange, ourToast as toast } from "../../utils";

const AddLocationTypeForm = ({ id, onComplete }) => {
  const [inputs, setInputs] = useState({});
  const [createLocationType, { loading }] = useMutation(
    CREATE_LOCATION_TYPE_MUTATION,
    {
      refetchQueries: ["ALL_LOCATION_TYPES_QUERY"]
    }
  );
  const handleChange = makeHandleChange(inputs, setInputs);

  const handleSave = async e => {
    e.preventDefault();
    try {
      await createLocationType({
        variables: {
          data: {
            LocationRecIdRef: parseInt(id),
            LocationTypeRecIdRef: parseInt(inputs.LocationTypeRecIdRef)
          }
        }
      });
      toast.success("Location Type added successfully.");
      onComplete();
    } catch (err) {
      toast.error("Error adding Location Type.");
    }
  };
  return (
    <form
      className="add-location-type-form"
      id="add-location-type-form"
      onSubmit={handleSave}
    >
      <Title>Add Location Type</Title>
      <Fieldset disabled={loading}>
        <LocationTypeForm inputs={inputs} onChange={handleChange} />
        <hr />
        <Field kind="group">
          <Control>
            <Button color="success" form="add-location-type-form" type="submit">
              Submit
            </Button>
          </Control>
          <Control>
            <Button type="button" onClick={onComplete}>
              Cancel
            </Button>
          </Control>
        </Field>
      </Fieldset>
    </form>
  );
};

AddLocationTypeForm.propTypes = {
  id: PropTypes.number.isRequired,
  onComplete: PropTypes.func.isRequired
};

export default AddLocationTypeForm;
